import { render, staticRenderFns } from "./UpdateStatementsModal.vue?vue&type=template&id=65e79ee9&scoped=true"
import script from "./UpdateStatementsModal.vue?vue&type=script&lang=js"
export * from "./UpdateStatementsModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatementsModal.vue?vue&type=style&index=0&id=65e79ee9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e79ee9",
  null
  
)

export default component.exports